
import { createClient } from '@supabase/supabase-js';
import { Database } from './database.types';

// Get Supabase URL and key from environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "https://xjqjinmmrfjuwfyumhbt.supabase.co";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhqcWppbm1tcmZqdXdmeXVtaGJ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwOTg4NDUsImV4cCI6MjA1ODY3NDg0NX0.98-cj0m_iKjFAY8c5dVBWlvJ8cOXQ1crjvej8wf-CCw";

// Check if Supabase credentials are available
const isMissingCredentials = !supabaseUrl || !supabaseAnonKey;

if (isMissingCredentials) {
  console.warn(
    '⚠️ Supabase credentials missing! Using fallback configuration.'
  );
}

// Create Supabase client
export const supabase = createClient<Database>(
  supabaseUrl, 
  supabaseAnonKey,
  {
    auth: {
      storage: typeof window !== 'undefined' ? localStorage : undefined,
      persistSession: true,
      autoRefreshToken: true,
    },
    global: {
      headers: {
        'X-Client-Info': 'chito-app'
      },
    }
  }
);
